import { GGOBaseComponent, Translate } from '@galigeo-store/ui-lib';
import { html } from 'lit';
import { customElement, state } from 'lit/decorators.js';
import { LogController } from '../../../controllers/log-controller.js';
import type { TableCell } from '@galigeo-store/ui-lib';

@customElement('log-admin-page')
export class LogAdminPage extends GGOBaseComponent {
  sync_schema_in_progress = false;
  sync_schema_done = false;

  @state() private logs: any[] = [];
  @state() private filteredLogs: any[] = [];
  @state() private _loading = false;
  @state() private searchValue: string = '';
  @state() private selectedProduct: string | null = null;
  @state() private products: { id: string | null; label: string }[] = [];

  constructor() {
    super();
    this.loadLogs();
  }

  async loadLogs() {
    this._loading = true;
    try {
      this.logs = await LogController.getLogs();
      this.buildProductsFilter();
      this.applyFilters();
    } catch (err) {
      console.error('Failed to load logs:', err);
      this.logs = [];
    } finally {
      this._loading = false;
    }
  }

  buildProductsFilter() {
    const uniqueProducts = Array.from(new Set(this.logs.map(l => l.product || '')));
    this.products = [
      ...uniqueProducts.map(p => ({ id: p, label: p || 'N/A' })),
    ];
  }

  applyFilters() {
    let filtered = this.logs;

    if (this.selectedProduct !== null) {
      filtered = filtered.filter(l => l.product === this.selectedProduct);
    }

    if (this.searchValue) {
      const search = this.searchValue.toLowerCase();
      filtered = filtered.filter(
        l =>
          l.username?.toLowerCase().includes(search) ||
          l.action?.toLowerCase().includes(search) ||
          l.msg?.toLowerCase().includes(search) ||
          l.product?.toLowerCase().includes(search) ||
          l.profile?.toLowerCase().includes(search),
      );
    }

    this.filteredLogs = filtered;
  }


  renderLogsTable() {
    if (this._loading) {
      return html`<ggo-spinner></ggo-spinner>`;
    }

    if (!this.filteredLogs.length) {
      return html`<div class="slds-text-align_center slds-m-top_medium">
        <span class="slds-text-title">Aucun log disponible</span>
      </div>`;
    }

    const fields = [
      { name: Translate.get('date') },
      { name: Translate.get('user') },
      { name: Translate.get('action') },
      { name: Translate.get('message') },
      { name: Translate.get('category') },
      { name: Translate.get('profile') },

    ];

    const rows = this.filteredLogs.map((log) => {
      return [
        new Date(log.created_at).toLocaleString(),
        log.username,
        log.action,
        {
          cell: html`<span class="slds-truncate" title=${log.msg}>${log.msg}</span>`,
          value: log.msg,
        } as TableCell,
        log.product,
        log.profile,

      ];
    });

    return html`
      <ggo-table
        .fields=${fields}
        .rows=${rows}
        maxLines=${1000}
        style='height: calc(100vh - 300px);'
        .rowTitle=${['Utilisateur', 'Action']}
      ></ggo-table>
    `;
  }

  render() {
    return html`
      <admin-header title="${Translate.get('admin_logs_desc')}"></admin-header>

      <div class="slds-m-around_medium">
      

        <!-- Barre de recherche + filtre produit -->
        <div class="slds-grid slds-grid_align-spread slds-m-bottom_small">
          <ggo-text-input
            class="slds-align-middle slds-m-right_small"
            placeholder="Rechercher..."
            @text-input=${(e: CustomEvent) => {
        this.searchValue = e.detail;
        this.applyFilters();
      }}
          ></ggo-text-input>

          <ggo-combobox
            placeHolder="Filtrer par produit"
            .values=${this.products}
            .selectedValue=${this.products.find(p => p.id === this.selectedProduct)}
            @changed=${(e: CustomEvent) => {
        this.selectedProduct = e.detail?.id ?? null;
        this.applyFilters();
      }}
          ></ggo-combobox>
        </div>

        ${this.renderLogsTable()}
      </div>
    `;
  }
}
